export default class Page {

	constructor( namespace ) {

		this.namespace = namespace
		this.beforeEnter = this.beforeEnter.bind( this )
		this.afterEnter = this.afterEnter.bind( this )
		this.beforeLeave = this.beforeLeave.bind( this )
		this.afterLeave = this.afterLeave.bind( this )

		this.view = {

			namespace: this.namespace,
			beforeEnter: this.beforeEnter,
			afterEnter: this.afterEnter,
			beforeLeave: this.beforeLeave,
			afterLeave: this.afterLeave

		}

	}

	beforeEnter() {

	}
	afterEnter() {

	}
	beforeLeave() {

	}
	afterLeave() {

	}

}
